module.exports = __webpack_public_path__ + "8f56abc7ff03d059a3248c9ff87d8b4e.png";


//////////////////
// WEBPACK FOOTER
// ../images/content_download_survey/email.png
// module id = 2492
// module chunks = 69